import { render, staticRenderFns } from "./course_mobile.vue?vue&type=template&id=720d371b&scoped=true&"
import script from "./course_mobile.vue?vue&type=script&lang=js&"
export * from "./course_mobile.vue?vue&type=script&lang=js&"
import style0 from "./course_mobile.vue?vue&type=style&index=0&id=720d371b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d371b",
  null
  
)

export default component.exports